export const textEllipsis = (value = '', length) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.length > length ? value.substring(0, length) + '...' : value;
};
